import { ProgramasPermtidosPorCestasService } from './../programas-permitidos-por-cestas.service';
import { Component,OnInit, TemplateRef, ViewChild, HostListener } from '@angular/core';
import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { ProgramaRepasseBndes } from 'src/app/model/programas-permitidos.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { ProgramaBndes } from 'src/app/model/dominio-operacao.model';
import { ActivatedRoute} from '@angular/router';
import { MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ModalidadeGarantia } from 'src/app/model/modalidade_garantia.model';
import { ModalidadeGarantiaService } from '../../modalidade_garantia/modalidade-garantia.service';

@Component({
    selector: 'app-programas-permitidos-por-cestas-pesquisa',
    templateUrl: './programas-permitidos-por-cestas-pesquisa.component.html',
    styleUrls: ['./programas-permitidos-por-cestas-pesquisa.component.scss'],
    standalone: false
})
export class ProgramasPermitidosPorCestasPesquisaComponent implements OnInit {

  public programasPermitidos: ProgramaRepasseBndes[] = [];
  public tranches: Tranche[] = [];
  public ideTranche: number;
  public pesquisado: boolean = false;
  public podeCadastrar: boolean;
  public codigo: number;
  public descricao: string;
  public esco: boolean;
  public modalidade: ModalidadeGarantia;

  @ViewChild('botoesCadastro') botoesPersonalizadosCadastro: TemplateRef<any>;
  @ViewChild('bodyCadastro') msgPersonalizadaCadastro: TemplateRef<any>;

  constructor(
    private modalidadeGarantiaService: ModalidadeGarantiaService,
    private trancheService: TrancheService,
    private programasPermitidosPorCestas: ProgramasPermtidosPorCestasService,
    private permissaoService: PermissaoService,
    private modalService: BnModalMessageService,
    public service: ProgramasPermtidosPorCestasService,
    private activatedRoute: ActivatedRoute,
    private messageService: MessageChannelService
  ) {
  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this. buscarTodosPorTranche()
  }

  ngOnInit(): void {
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp => {
      this.podeCadastrar = resp && resp[ROLE_GESTOR_ENVIO];
      this.modalidadeGarantiaService.buscarModalidade().subscribe((modalidade:any) => {
        this.modalidade = modalidade;
      })
    })
    this.trancheService.getTranches().subscribe(tranches => {
      this.tranches = tranches;
    });

  }

  public buscarTodosPorTranche() {
    if(this.ideTranche){
    this.pesquisado = false;
    this.programasPermitidosPorCestas.buscarProgramasPermitidosPorTranche(this.ideTranche).subscribe
      ((ids: ProgramaRepasseBndes[]) => {
        this.programasPermitidos = ids;
        this.pesquisado = true;
      })
  }
}

  

  public buscaTranche() {
    console.log(this.ideTranche);
  }

  public limpar() {
    this.ideTranche = null;
    this.pesquisado = false;
  }

  abrirModalCadastro(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
    if (hasBotoes === true && hasMsgTemplate === true) {
      this.modalService.abrir('Cadastro de programa permitido por cesta', msg, tamanho, this.msgPersonalizadaCadastro, this.botoesPersonalizadosCadastro);
    }
  }

  close() {
    this.modalService.close();
  }

  dismiss() {
    this.codigo = null;
    this.descricao = null;
    this.modalService.dismiss();
  }

  public salvarHabilitar() {
    let dto: any = {}
    if (this.codigo) {
      dto.id = this.codigo
    }
    if (this.esco) {
      dto.indicadorEsco = this.esco
    } else {
      dto.indicadorEsco = false
    }
    console.log(dto)

    this.service.habilitar(this.ideTranche, dto).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Novo programa habilitado com sucesso'
      });
      this.dismiss();
      this.buscarTodosPorTranche();
    })
  }

  public salvarCadastrar() {
    if (!this.codigo || !this.descricao) {
      return;
    }

    let dto: any = {}
    if (this.codigo) {
      dto.id = this.codigo;
      dto.descricaoPrograma = this.descricao;
    }

    console.log(dto)

    this.service.cadastrar(this.ideTranche, dto).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Novo programa incluído com sucesso'
      });
      this.dismiss();
    })
  }

  // selecionarPrograma(programa: ProgramaBndes) {
  //   console.log('codigo', programa.id);

  //   this.codigo = Number(programa.id);
  // }

}
